import React from "react";
import { CircleDollarSign, BadgeCheck, ShieldOff, PackageCheck, ArrowRight } from "lucide-react";

const POINTS = [
  {
    icon: CircleDollarSign,
    title: "Flat monthly subscription",
    body: "No per-device license, no per-seat fees, no surprise costs.",
  },
  {
    icon: BadgeCheck,
    title: "Enterprise volume discounts",
    body: "Built for high-throughput refurb operations that scale.",
  },
  {
    icon: ShieldOff,
    title: "Never pay for a failed wipe",
    body: "You're billed for the service, not per attempt.",
  },
  {
    icon: PackageCheck,
    title: "Plug-and-play stations",
    body: "Shipped pre-configured — controller, switch, eraser image, and cloud link already set up.",
  },
];

const Pricing = () => {
  return (
    <section id="pricing" className="relative bg-brand-bg font-body">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-28">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-white px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-brand-plum">
            Pricing &amp; getting started
          </span>
          <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-brand-plum sm:text-4xl lg:text-5xl">
            Priced for Volume, Not Per <span className="text-brand-gradient">Attempt</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink sm:text-lg">
            Power on and start wiping — no multi-day setup project, no specialist training, no paying for
            wipes that don&apos;t complete.
          </p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {POINTS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col rounded-2xl border border-line bg-white p-6 transition-all hover:-translate-y-1 hover:border-brand-orchid hover:shadow-xl hover:shadow-brand-plum/5"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-brand-wash text-brand-magenta ring-1 ring-brand-orchid/30">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-display text-base font-semibold text-brand-plum">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted">{body}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="#pilot"
            className="group inline-flex items-center gap-2 rounded-full bg-cta-gradient px-6 py-3.5 text-sm font-semibold text-white no-underline shadow-lg shadow-[#304BEF]/25 transition-transform duration-200 hover:-translate-y-0.5 hover:no-underline"
          >
            Join the Furloop Poofed pilot program
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
